import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { environment } from "src/environments/environment";
import { ActivatedRoute, Router } from "@angular/router";


@Component({
    selector: 'needs-reconciliation-list',
    templateUrl: './needs-reconciliation-list.component.html',
    styleUrls: ['./needs-reconciliation-list.component.scss']
})
export class NeedsReconciliationListComponent implements OnInit {


    locationSelected = "Stockport";
    checkTypeSelected = "";
    dateSelected = new Date().toDateString();

    selectedDateIsToday = false;
    loading = 0;

    readonly locations: string[] = [
        "Stockport",
        "Oldham",
        "Preston",
        "Chester"
    ];

    private readonly AllCheckTypesOption = "All Check Types";
    readonly checkTypes: string[] = [
        this.AllCheckTypesOption,
        "Vehicle Presence Check",
        "Vehicle Key Check",
        "Vehicle Locked Check"
    ];

    uncheckedVehicles: string[] = [];


    /**
     *
     */
    constructor(private authService: MsalService,
                private httpservice: HttpClient,
                private route: ActivatedRoute,
                private router: Router) {        
    }

    ngOnInit(): void {
        const params = this.route.snapshot.queryParams;

        this.applySearchParams(params.location, params.year, params.month, params.day);
        //this.retrieveLocationChecks();
        this.getReconciliationList();
    }

    applySearchParams(location: string | undefined, year: string | undefined, month: string  | undefined, day: string  | undefined){
        if (location){
            this.locationSelected = location;
        }

        if (year && month && day){
            const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
            this.dateSelected = date.toDateString();
        }
    }

    onDateChanged(dateString: string){
        if (!dateString){
            return;
        }

        this.getReconciliationList();
    }
    onSelectionChanged(location: string){
        this.getReconciliationList();
    }

    get dateObject(){
        return new Date(this.dateSelected);
    }

    get selectedYear(){
        return this.dateObject.getFullYear();
    }

    get selectedMonth(){
        return this.dateObject.getMonth() + 1;
    }

    get selectedDay(){
        return this.dateObject.getDate();
    }


    getReconciliationList(){
        this.loading++;
        const account = this.authService.instance.getAllAccounts()[0];
        const accessTokenRequest = {
            scopes: ["user.read"],
            account: account,
            };

        this.authService.acquireTokenSilent(accessTokenRequest).subscribe(x => {
            const accessToken = x.accessToken;


            //get unchecked vehicles
            this
            .getUncheckedVechicles(accessToken, this.locationSelected, this.selectedYear, this.selectedMonth, this.selectedDay)
            .subscribe(x => {
                if (x != null && x.result != null){
                    this.uncheckedVehicles = x.result;
                    console.log(this.uncheckedVehicles);
                    this.loading--;
                }
            });
        });

        
    }

    //get unchecked vehicles
    getUncheckedVechicles(accessToken: string, location: string, year: number, month: number, day: number){

        const url = environment.apiUrl + `api/v2/closingchecks/MissingRegsFromChecks?location=${location}&year=${year}&month=${month}&day=${day}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    getIsRegMarkAsPresent(accessToken: string, reg: string, location: string, year: number, month: number, day: number){

        const url = environment.apiUrl + `api/v2/closingchecks/MissingRegsFromChecks?reg=${reg}&location=${location}&year=${year}&month=${month}&day=${day}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }
    
    getTodaysVehicleChecks(accessToken: string, location: string){

        const url = environment.apiUrl + `api/v2/closingchecks/TodaysVehicleChecksByLocation?location=${location}}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    getVehicleChecksByDate(accessToken: string, location: string, year: number, month: number, day: number){

        const url = environment.apiUrl + `api/v2/closingchecks/GetVehicleChecksByLocationAndDate?location=${location}&year=${year}&month=${month}&day=${day}`;
        const getObservable = this.httpservice.get<any>(
            url,
            {
                headers: { 
                    "Authorization": accessToken,
                    'Accept': 'application/json', 
                },
                'responseType': 'json'
            },
        );
        return getObservable;
    }

    redirectToReconciliation(reg: string){
        const path = '/site-checks/reconcile';

        const unixTime = Math.floor(this.dateObject.getTime() / 1000);
        const url = `${path}?reg=${reg}&checkindate=${unixTime}`;

        this.router.navigateByUrl(url);
    }

}